import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d814d7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fb-trailer-side-selector fb-body-damage-selector" }
const _hoisted_2 = {
  version: "1.1",
  class: "fb-svg truck-trailer-arial",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 141 535.5",
  style: {"enable-background":"new 0 0 141 535.5"},
  "xml:space": "preserve"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path truck-arial",
  d: "M140.5,58.9c0,0.7-0.5,1.2-1.2,1.2h-8.1c-0.5,0-1-0.3-1.2-0.8c-1.2,0.4-2.8,0.9-4.5,1.4 c-1.3,1.9-3.2,3.5-5.4,4.3v38l6.2,4.4v11.2c-1.3-2.4-3-4.6-4.8-6.6l-3.2-3.5c-1-2.1-9.9-18.3-29.2-23.8c-12.1-3.3-24.8-3.3-36.9,0 c-18.2,4.9-28.3,21.8-29.2,23.8l-3.2,3.5c-1.9,2-3.5,4.2-4.9,6.6v-11.3L21,103V65c-2.2-0.9-4.2-2.4-5.6-4.3c-1.7-0.5-3.3-1-4.5-1.4 c-0.2,0.5-0.6,0.8-1.2,0.8H1.7c-0.7,0-1.2-0.6-1.2-1.2c0,0,0,0,0,0v-2c0-1.3,1-2.3,2.3-2.3h0h5.9c1.1,0.1,2,0.9,2.4,1.9l2.6,0.6 c-0.4-1.3-0.7-2.6-0.7-3.9L13,34.5c0.5-11.8-2.9-31.2,32.8-33.7L28.7,52.1c-0.2,0.4-0.4,0.8-0.5,1.3c-1,2.5-2.4,7.1-2.7,8.1 c0,0.9,0.7,1,1.5,0.5c3.2-2.2,6.8-3.8,10.6-4.8c9.7-2.6,22.3-2.6,31.7-2.6c10.1,0,23.8-0.1,34.2,2.6c3.8,0.9,7.4,2.5,10.6,4.8 c0.8,0.5,1.5,0.5,1.5-0.5c-0.3-1-1.8-5.7-2.7-8.1c-0.2-0.4-0.3-0.9-0.5-1.3L95.2,0.8c35.7,2.5,32.3,21.9,32.8,33.7l0.1,18.7 c0,1.3-0.2,2.7-0.7,3.9l2.6-0.6c0.3-1.1,1.3-1.8,2.4-1.9h5.9c1.3,0,2.3,1,2.3,2.3l0,0L140.5,58.9z M123.8,20.8 c0.2,0.3,0.5,0.4,0.8,0.2c0.6-0.4,0.7-1.9,0.3-2.8c-1.4-4.2-4.3-7.8-8-10.2c-6.4-4-14.5-4.2-18.6-4.4C110.3,8,116.5,13.4,123.8,20.8 L123.8,20.8z M16.2,21.1c0.3,0.2,0.6,0,0.8-0.2C24.3,13.4,30.6,8,42.6,3.6C38.5,3.8,30.3,4.1,23.9,8c-3.8,2.4-6.6,6-8,10.2 c-0.1,0.4-0.2,0.8-0.2,1.2C15.6,20.1,15.8,20.7,16.2,21.1L16.2,21.1z M129.4,161.9h-19.5l-2.3-10.6c-0.4-1.9-2.1-3.3-4.1-3.3H37.6 c-2,0-3.7,1.4-4.1,3.3l-2.3,10.6H11.8v-26c0-4.9,1-9.8,3.1-14.3c0-3.3,8.2-11.7,8.9-12.5C31.6,96,43.8,88.1,52.3,85.8 c14.3-2.9,23.1-2.9,36.5,0c8,2.2,21.8,10.6,28.6,23.4c1.5,1.6,8.9,9.2,8.9,12.4c2,4.5,3.1,9.4,3.1,14.4L129.4,161.9z M126.2,192.1 h-27v-41.7h4.1c0.8,0,1.6,0.6,1.8,1.4l2.7,12.5h18.4L126.2,192.1z M107.9,49.6c-2.3-0.8-5.1-1.3-10.9-1.7 c-8.2-0.5-16.8-0.7-26.5-0.7c-9.7-0.1-18.3,0.1-26.5,0.7c-5.9,0.4-8.7,0.9-10.9,1.7c-0.7,0.2-1.3,0.5-1.9,0.9L47.3,0.7 c2.2-0.1,4.3-0.2,6.9-0.2h32.7c2.5,0,4.6,0.1,6.9,0.2l16.1,49.8C109.2,50.1,108.6,49.8,107.9,49.6L107.9,49.6z M41.8,192.1h-27 v-27.8h18.5l2.7-12.5c0.2-0.8,0.9-1.4,1.8-1.4h4.1L41.8,192.1z"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path trailer-arial",
  d: "M11.8,171.8v361.7h117.6V171.8H11.8z"
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrailerDamageLayout = _resolveComponent("TrailerDamageLayout")!

  return (_openBlock(), _createBlock(_component_TrailerDamageLayout, null, {
    damageType: _withCtx(() => [
      _createTextVNode("(Body Damage)")
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5)),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-outline-dark input-radius fb-btn-selector front", _ctx.frontButton]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.frontTapped && _ctx.frontTapped(...args)))
        }, _hoisted_7, 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-outline-dark input-radius fb-btn-selector driver", _ctx.driverButton]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.driverTapped && _ctx.driverTapped(...args)))
        }, _hoisted_9, 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-outline-dark input-radius fb-btn-selector passenger", _ctx.passengerButton]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.passengerTapped && _ctx.passengerTapped(...args)))
        }, _hoisted_11, 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-outline-dark input-radius fb-btn-selector back", _ctx.rearButton]),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.rearTapped && _ctx.rearTapped(...args)))
        }, _hoisted_13, 2)
      ])
    ]),
    _: 1
  }))
}